// src/utils/unsplashErrors.ts

// Backend zwraca stabilne `code` w ciele odpowiedzi właśnie po to, żeby front nie rozpoznawał
// sytuacji po treści komunikatu ani po samym statusie HTTP.
// Wyczerpana pula musi mieć inny komunikat niż awaria — to jest stan, dla którego powstało R9.
const ERROR_TRANSLATION_KEYS: Record<string, string> = {
  UNSPLASH_RATE_LIMIT: 'words-list:images.errors.rateLimit',
  UNSPLASH_UNAVAILABLE: 'words-list:images.errors.unavailable',
  UNSPLASH_NOT_CONFIGURED: 'words-list:images.errors.notConfigured',
  UNSPLASH_PHOTO_NOT_FOUND: 'words-list:images.errors.photoNotFound',
};

// Nieznany kod, brak odpowiedzi (sieć), 400 z walidacji — wszystko to jest dla nauczyciela
// tym samym: nie udało się i można spróbować ponownie.
export const unsplashErrorKey = (error: any): string => {
  const code = error?.response?.data?.code;

  return ERROR_TRANSLATION_KEYS[code] || 'words-list:images.errors.generic';
};
